import { serverFetch } from "@core/server";

export function fetchSprKomplList() {
  return serverFetch("sprs/kompl");
}

export function fetchSprKompl(idKompl) {
  return serverFetch(`sprs/kompl/${idKompl}`);
}

export function createSprKompl(bodyData) {
  return serverFetch("sprs/kompl", {
    method: "POST",
    bodyData
  });
}

export function saveSprKompl(idKompl, bodyData) {
  return serverFetch(`sprs/kompl/${idKompl}`, {
    method: "PUT",
    bodyData
  });
}

export function deleteSprKompl(idKompl) {
  return serverFetch(`sprs/kompl/${idKompl}`, {
    method: "DELETE"
  });
}

export function fetchSprKomplItems(idKompl) {
  return serverFetch(`sprs/kompl/${idKompl}/items`);
}

export function createSprKomplItem(idKompl, bodyData) {
  return serverFetch(`sprs/kompl/${idKompl}/items`, {
    method: "POST",
    bodyData
  });
}

export function saveSprKomplItem(idKompl, idStr, bodyData) {
  return serverFetch(`sprs/kompl/${idKompl}/items/${idStr}`, {
    method: "PUT",
    bodyData
  });
}

export function deleteSprKomplItem(idKompl, idStr) {
  return serverFetch(`sprs/kompl/${idKompl}/items/${idStr}`, {
    method: "DELETE"
  });
}
